export default (params) => ({
  trigger: {
    name: 'active_mailer.focus_input',
    params: params,
  },
  config: {
    schema: {
      input_field: {
        type: 'string',
      },
      status: {
        enum: [
          'success',
          'failure',
          'focus',
          'checked',
          'unchecked',
          'recovered',
        ],
      },
    },
    event: {
      name: 'select_input_field',
      params: {
        sub_feature: 'active_mailer_overlay',
        content: null,
      },
    },
  },
});
